import { DEXT_FIELD_TYPES } from './dext-field-types';
import { INPUT_FIELD_TYPES, isInputFieldType, isQuizFieldType, CONTACTS_FIELD_TYPES, COMMON_FIELD_TYPES, PAYMENTS_FIELD_TYPES, QUIZ_FIELD_TYPES, EVENTS_FIELD_TYPES } from './input-field-types';
import { READONLY_FIELD_TYPES } from './readonly-field-types';
export const FIELD_TYPES = {
    ...INPUT_FIELD_TYPES,
    ...READONLY_FIELD_TYPES,
    SUBMIT_BUTTON: 'SUBMIT_BUTTON'
};
export { INPUT_FIELD_TYPES, isInputFieldType, isQuizFieldType, CONTACTS_FIELD_TYPES, COMMON_FIELD_TYPES, PAYMENTS_FIELD_TYPES, QUIZ_FIELD_TYPES, READONLY_FIELD_TYPES, DEXT_FIELD_TYPES, EVENTS_FIELD_TYPES };

//# sourceMappingURL=field-types.js.map